import React from "react";

import { useTheme } from "@mui/material/styles";

import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";

const CardSuccessPayment = ({ handleUpdatePayment }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        width: "100%",
        minWidth: "100%",
        margin: "auto",
        borderRadius: "16px",
        boxShadow: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // Centrar el contenido verticalmente
        alignItems: "center",
        textAlign: "center",

        /* [theme.breakpoints.up("sm")]: { width: "50%" }, */
        [theme.breakpoints.up("md")]: { width: "50%" },
        [theme.breakpoints.up("lg")]: { width: "100%" },
      }}
    >
      <CardContent
        sx={{
          width: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Texto principal */}
        <Typography
          variant="h3"
          gutterBottom
          sx={{
            fontSize: "30px",
            padding: "2rem 0",
            margin: "0",
            "@media (max-width: 1360px)": {
              padding: "1rem 0",
              fontSize: "25px",
            },
          }}
        >
          Confirmación De Pago
        </Typography>

        {/* Icono con el círculo y los elementos decorativos */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#E0F7FA",
            borderRadius: "50%",
            width: 100,
            height: 100,
            position: "relative",
            mb: 3,

            "@media (max-width: 1360px)": {
              width: 70,
              height: 70,
            },
          }}
        >
          <CheckCircleOutlineIcon
            sx={{
              fontSize: 48,
              color: "#00C853",
              "@media (max-width: 1360px)": {
                fontSize: 40,
              },
            }}
          />
          {/* Elementos decorativos (pequeños círculos alrededor) */}
          <Box
            sx={{
              position: "absolute",
              top: -10,
              left: 20,
              width: 5,
              height: 5,
              bgcolor: "#FFAB40",
              borderRadius: "50%",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: 20,
              right: -10,
              width: 5,
              height: 5,
              bgcolor: "#FF4081",
              borderRadius: "50%",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: -10,
              left: 10,
              width: 5,
              height: 5,
              bgcolor: "#7C4DFF",
              borderRadius: "50%",
            }}
          />
        </Box>

        {/* Texto principal */}
        <Typography
          variant="h4"
          gutterBottom
          color="warning.success"
          sx={{ fontSize: "18px" }}
        >
          Pago Exitoso !
        </Typography>

        {/* Texto secundario */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3, px: 2 }}
        >
          Tu pago fue procesado exitosamente. Puedes revisarlo en la sección
          PAGOS. Si tienes algún inconveniente contactate con nuestro call
          center al 023811960.
        </Typography>

        {/* Botón */}
        <SCSGenericButton
          titulo="ACTUALIZAR"
          size={50}
          onClick={handleUpdatePayment}
        />
      </CardContent>
    </Card>
  );
};

export default CardSuccessPayment;
